import { makeStyles } from '@material-ui/core';
import { themeColor } from 'src/mui-theme';

export interface Props {
  operational?: boolean;
}

export const useStyles = makeStyles(() => ({
  root: ({ operational }: Props) => ({
    fill: operational ? themeColor.palesky : themeColor.alert,
    opacity: operational ? 0.4 : 1,
  }),
}));
